import FieldDropdown from "../../../generic/dropdown/dropdown";
import FieldToDoListTemplate_AutomationActionForm from "./render/automation-action-form";

export default class FieldToDoListTemplate extends FieldDropdown {

    constructor(config:any) {
        super(config)

        this.typeLabel          = "To-do list template"
        // this.typeGroup          = GROUP_INFO
        this.typeDescription    = "To-do list template"
        this.icon               = 'i5-todo'

        _.assign(this.renderComponents,{
            automationActionForm    : FieldToDoListTemplate_AutomationActionForm
        })

        this.options            = gd.session.todoListTemplates.exportToOptions()

        this.noValueOption      = _.get(config,'noValueOption',false)   // redefine default to false
        this.isSearchable       = false;

        // this.showMenuMore       = false - this doesnt make any differences...
        this.components.PopoverMenuMore = null
    }

    /*** DATA FUNCTIONS ***/

    groupValue(value:any) {
        return value
    }

    sortValue(value:any) {
        const todoListTemplate = gd.session.todoListTemplates.get(value);
        return todoListTemplate ? todoListTemplate.name : ''
    }

}